import {normalize} from '../../util/utils';
import * as types from '../../actions/actiontypes';

export default function reducer(state = {}, action) {
	switch (action.type) {
		case types.GET_ACCOUNTS:
			if (action.response && action.response.data && !action.isManageAccounts) {
				const _risks = action.response.data
					.flatMap((account) => account.assertions || [])
					.flatMap((assertion) => assertion.risks || []);
				const newState = action.mergeStrategy
					? normalize(_risks, undefined, state,action.mergeStrategy)
					: normalize(_risks);
				return newState;
			}
			return state;
		default:
			return state;
	}
}
